<template>
    <card-skeleton :class-name="className" :is-loading="isLoading">
        <v-card-item>
            <slot />
        </v-card-item>
    </card-skeleton>
</template>

<script setup lang="ts">
import { IFieldSection } from '../types';
import CardSkeleton from '@/features/common/components/CardSkeleton.vue';

defineProps<IFieldSection>();
</script>
